import type { ReactNode } from "react";
import {
  WelcomeBlock,
  WelcomeControls,
  WelcomeRow,
  WelcomeSubtitle,
  WelcomeTitle,
} from "./style";

interface WelcomeBarProps {
  name: string;
  subtitle: string;
  controls?: ReactNode;
}

export default function WelcomeBar({ name, subtitle, controls }: WelcomeBarProps) {
  return (
    <WelcomeRow align="flex-start" justify="space-between" gap={16} wrap="wrap">
      <WelcomeBlock vertical gap={4}>
        <WelcomeTitle level={2}>Welcome back, {name}!</WelcomeTitle>
        <WelcomeSubtitle>{subtitle}</WelcomeSubtitle>
      </WelcomeBlock>
      {controls && (
        <WelcomeControls align="center" gap={12} wrap="wrap">
          {controls}
        </WelcomeControls>
      )}
    </WelcomeRow>
  );
}
